<form [formGroup]="productGroupForm">
  <markant-select formControlName="selectedProductGroup" [required]="!allowEmpty" ngDefaultControl label="Warenbereich">
    <markant-select-option value="all" *ngIf="allowEmpty"><em>(alle)</em></markant-select-option>
    <markant-select-option-group *ngFor="let group of productCategories" [label]="group.name" [disabled]="group.disabled">
      <markant-select-option *ngFor="let productGroup of group.productGroups" [value]="productGroup.value">
        {{ productGroup.viewValue }}
      </markant-select-option>
    </markant-select-option-group>
  </markant-select>
</form>
